import { computed, inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { TimesheetStatusService, TimesheetStatusSummary } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class TimesheetStatusQueryService {
  private readonly timesheetStatusService = inject(TimesheetStatusService);

  statusesQuery = injectQuery(() => ({
    queryKey: [QueryKey.TIMESHEET_STATUSES],
    queryFn: () => lastValueFrom(this.timesheetStatusService.getTimesheetStatuses()),
  }));

  statuses = computed<TimesheetStatusSummary[]>(() => this.statusesQuery.data()?.timesheetStatuses ?? []);
  isLoading = computed(() => this.statusesQuery.isLoading());
}
